import React, { useState } from 'react';
import { Star, Building2, ShoppingBag } from 'lucide-react';
import { shopProducts, shopCategories } from '../mock';
import ProductSheet, { b2bInfo } from './ProductSheet';

export default function Shop() {
  const [cat, setCat] = useState('All');
  const [b2b, setB2b] = useState(false);
  const [active, setActive] = useState(null);

  const list = cat === 'All' ? shopProducts : shopProducts.filter((p) => p.cat === cat);

  return (
    <div className="pb-6">
      <div className="px-4 pt-4">
        <div className="flex bg-[#0a0f18] rounded-xl p-1">
          <button onClick={() => setB2b(false)} className={`flex-1 flex items-center justify-center gap-1.5 py-2 rounded-lg text-[13px] font-semibold transition-colors ${!b2b ? 'bg-[#2f8bff] text-white' : 'text-[#8b95a5]'}`}>
            <ShoppingBag size={15} /> Retail
          </button>
          <button onClick={() => setB2b(true)} className={`flex-1 flex items-center justify-center gap-1.5 py-2 rounded-lg text-[13px] font-semibold transition-colors ${b2b ? 'bg-[#2f8bff] text-white' : 'text-[#8b95a5]'}`}>
            <Building2 size={15} /> B2B / Wholesale
          </button>
        </div>
      </div>

      <div className="flex gap-2 overflow-x-auto no-scrollbar px-4 py-3">
        {shopCategories.map((c) => (
          <button key={c} onClick={() => setCat(c)} className={`shrink-0 px-3.5 py-1.5 rounded-full text-[13px] font-medium transition-colors ${cat === c ? 'bg-white text-[#05070c]' : 'bg-[#141c28] text-[#c4ccd8]'}`}>{c}</button>
        ))}
      </div>

      <div className="grid grid-cols-2 gap-3 px-4">
        {list.map((p) => {
          const { wholesale, moq } = b2bInfo(p);
          return (
            <button key={p.id} onClick={() => setActive(p)} className="text-left bg-[#0c1420] rounded-2xl overflow-hidden ring-1 ring-[#141c28] active:scale-[0.98] transition-transform animate-fade-up">
              <div className="relative">
                <img src={p.image} alt="" className="w-full aspect-square object-cover bg-white/5" />
                {p.tag && <span className="absolute top-2 left-2 text-[10px] font-bold text-white bg-[#f43f5e] px-2 py-0.5 rounded-full">{p.tag}</span>}
              </div>
              <div className="p-3">
                <p className="text-[13px] font-semibold text-white truncate">{p.name}</p>
                <div className="flex items-center gap-1 mt-0.5">
                  <Star size={11} className="fill-[#f5a524] text-[#f5a524]" />
                  <span className="text-[11px] text-[#8b95a5]">{p.rating} · {p.seller}</span>
                </div>
                {b2b ? (
                  <>
                    <p className="text-[15px] font-bold text-white mt-1.5">₹{wholesale.toLocaleString()}<span className="text-[10px] font-normal text-[#8b95a5]">/unit</span></p>
                    <p className="text-[10px] text-[#2f8bff]">Min {moq} units</p>
                  </>
                ) : (
                  <p className="text-[15px] font-bold text-white mt-1.5">₹{p.price.toLocaleString()}</p>
                )}
              </div>
            </button>
          );
        })}
      </div>

      {active && <ProductSheet product={active} initialB2B={b2b} onClose={() => setActive(null)} />}
    </div>
  );
}
